<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <div class="row pl-4 pr-4" v-show="tela == 1">
            <h4 slot="header" class="card-title text-left">
              ABSENTEÍSMO ANALÍTICO
            </h4>
            <div>
              <BaseFiltroRelatorio
                :btEnviarEmail="false"
                :isMessage="false"
                :limitarData="true"
                :filterBancoHora="true"
                @pesquisar="pesquisar"
              />
            </div>
          </div>

          <div class="row pl-4 pr-4" v-if="tela == 2" id="imprimirFolha">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <!--Botoes de voltar e imprimir-->
              <div class="col-6 d-flex justify-content-start hidden-print">
                <base-button
                  v-show="!printing"
                  type="info"
                  class="animation-on-hover"
                  @click="tela = 1"
                  ><i class="tim-icons icon-minimal-left"></i>
                  Voltar</base-button
                >
              </div>
              <div class="col-6 d-flex justify-content-end hidden-print">
                <base-button
                  v-show="!printing"
                  type="info"
                  class="animation-on-hover"
                  @click="imprimirFolha()"
                  simple
                >
                  <i class="tim-icons icon-paper"></i> Imprimir
                </base-button>
              </div>

              <!--Cabecalho do resultado-->
              <div class="container p-3 rounded" style="background: #f9f9f9;">
                <div class="row">
                  <div class="col-12 col-sm-6">
                    <div class="row">
                      <div class="col text-left">
                        {{ `ABSENTEÍSMO ANALÍTICO` }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col text-left">
                        {{
                          `PERÍODO: ${moment(
                            payloadPesquisa.data_inicial
                          ).format("DD/MM/YYYY")} à
                      ${moment(payloadPesquisa.data_final).format(
                        "DD/MM/YYYY"
                      )}`
                        }}
                      </div>
                    </div>

                    <div class="row">
                      <div
                        class="col text-left"
                        v-if="payloadPesquisa.bancoHora"
                      >
                        {{ `BANCO DE HORAS: SIM` }}
                      </div>
                      <div class="col text-left" v-else>
                        {{ `BANCO DE HORAS: NÃO` }}
                      </div>
                    </div>

                    <div class="row">
                      <div
                        class="col text-left"
                        v-if="!payloadPesquisa.id_funcionario"
                      >
                        {{
                          `DEPARTAMENTO: ${
                            payloadPesquisa.departamento
                              ? payloadPesquisa.departamento.descricao
                              : "TODOS"
                          }`
                        }}
                      </div>
                      <div class="col text-left" v-else>
                        {{ `DEPARTAMENTO: NENHUM` }}
                      </div>
                    </div>
                    <div class="row">
                      <div
                        class="col text-left"
                        v-if="!payloadPesquisa.id_funcionario"
                      >
                        {{
                          `POSTO DE TRABALHO: ${
                            payloadPesquisa.posto
                              ? payloadPesquisa.posto.local
                              : "TODOS"
                          }`
                        }}
                      </div>
                      <div class="col text-left" v-else>
                        {{ `POSTO DE TRABALHO: NENHUM` }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col text-left">
                        {{
                          `TOTAL DE FUNCIONÁRIOS ENCONTRADOS: ${pagination.totalItems}`
                        }}
                      </div>
                    </div>

                    <div class="row">
                      <div class="col text-left">
                        {{
                          `RELATÓRIO GERADO EM: ${moment().format(
                            "DD/MM/YYYY HH:mm"
                          )}`
                        }}
                      </div>
                    </div>
                   
                  </div>
                   <div class="col-12 col-sm-6" style="font-size: 12px;">
                      <div class="m-0 p-0 text-left">
                        <b>LEGENDA:</b></br>
                        <b>FC</b> - Folga compensatória</br>
                        <b>AB</b> - Abono</br>
                        <b>FA</b> - Falta</br>
                        <b>FE</b> - Férias</br>
                        <b>FO</b> - Folga</br>
                        <b>FR</b> - Feriado</br>
                        <b>AT</b> - Atestado médico</br>
                        <b>LM</b> - Licença maternidade</br>
                      </div>
                   </div>
                </div>
              </div>

              <!--Tabela de resultados-->
              <div class="table-responsive p-3">
                <table class="table table-hover table-bordered">
                  <thead class="table-bordered">
                    <tr>
                      <th>Nome</th>
                      <th>B.Horas</th>
                      <th>Adc.Not</th>
                      <th v-for="item in dados[0].dias">
                        {{ item.dia }}
                      </th>
                      <th>FC</th>
                      <th>AB</th>
                      <th>FA</th>
                      <th>FE</th>
                      <th>FO</th>
                      <th>FR</th>
                      <th>AT</th>
                      <th>LM</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in dados" :key="item.cpf">
                      <td>{{ item.empregado || `` }}</td>
                      <td>{{ item.bancoHora }}</td>
                      <td>{{ item.noturno }}</td>
                      <td v-for="itemDia in item.dias">
                        {{ itemDia.evento }}
                      </td>
                      <td>{{ item.resumo.FC || 0 }}</td>
                      <td>{{ item.resumo.AB || 0 }}</td>
                      <td>{{ item.resumo.FA || 0 }}</td>
                      <td>{{ item.resumo.FE || 0 }}</td>
                      <td>{{ item.resumo.FO || 0 }}</td>
                      <td>{{ item.resumo.FR || 0 }}</td>
                      <td>{{ item.resumo.AT || 0 }}</td>
                      <td>{{ item.resumo.LM || 0 }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <Paginacao
                v-show="!printing"
                :currentPage="pagination.currentPage"
                :totalPages="pagination.totalPages"
                @page-changed="listarRelatorio"
              />
            </div>
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import {
  Card,
  BaseInput,
  BaseFiltroRelatorio,
  Paginacao,
} from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import swal from "sweetalert2";
import moment from "moment";

export default {
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseInput,
    BaseFiltroRelatorio,
    Paginacao,
  },
  computed: {},
  data() {
    return {
      pagination: {
        currentPage: 1,
        perPage: 50,
        totalItems: 0,
        totalPages: 0,
      },
      payloadPesquisa: Object,
      printing: false,
      isLoading: false,
      tela: 1, //1 filtros, 2 -resultados
      dados: [],
    };
  },
  mounted() {},
  methods: {
    pesquisar(event) {
      this.payloadPesquisa = event;
      this.listarRelatorio(1);
    },
    imprimir(event) {
      console.log("Clicou em imprimir");
      console.log(event);
      console.log("-------------------");
    },

    imprimirFolha() {
      this.printing = true;
      this.isLoading = true;

      try {
        this.$nextTick(() => {
          this.$htmlToPaper("imprimirFolha", null, () => {
            this.printing = false;
            this.isLoading = false;
          });
        });
      } catch (error) {
        console.error("Erro ao imprimir a folha:", error);
        this.isLoading = false;
        this.printing = false;
      }
    },

    moment: function(data) {
      return moment(data);
    },
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    listarRelatorio(page = 1) {
      let th = this;
      th.isLoading = true;
      const bodyFormData = {
        ...this.payloadPesquisa,
        page,
        limit: this.pagination.perPage,
      };
      this.axios
        .post("/api/relatorio/relatorioAbsenteismo", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          if (response.data.status == "success") {
            th.dados = response.data.data.funcionarios;
            th.pagination = response.data.data.paginacao;
            th.tela = 2;
          } else {
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao carregar relatório!",
              "error"
            );
          }
        })
        .catch((err) => {
          th.isLoading = false;
          console.log(err);
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao carregar relatório!",
            "error"
          );
        });
    },
  },
  watch: {},
};
</script>
<style>
thead th {
  border: 1px solid #dee2e6 !important;
  vertical-align: middle;
  text-align: center;
}
</style>
